export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: 'megagen-access_token',
  ROLE_TYPE: 'megagen-role_type',
} as const;

export type StorageKey =
  (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];
